import React from 'react';

import { SVGComponentProps } from './svg.types';

const ListSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      {/* <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2 6H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 10H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 2V14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      </svg> */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M11.7467 6.41309H8.24667C7.97334 6.41309 7.74667 6.18642 7.74667 5.91309C7.74667 5.63975 7.97334 5.41309 8.24667 5.41309H11.7467C12.02 5.41309 12.2467 5.63975 12.2467 5.91309C12.2467 6.18642 12.0267 6.41309 11.7467 6.41309Z"
          fill={fill}
        />
        <path
          d="M4.74665 6.92021C4.61999 6.92021 4.49332 6.87354 4.39332 6.77354L3.89332 6.27354C3.69999 6.08021 3.69999 5.76021 3.89332 5.56688C4.08665 5.37354 4.40665 5.37354 4.59999 5.56688L4.74665 5.71354L5.89332 4.56688C6.08665 4.37354 6.40665 4.37354 6.59999 4.56688C6.79332 4.76021 6.79332 5.08021 6.59999 5.27354L5.09999 6.77354C5.00665 6.86687 4.87999 6.92021 4.74665 6.92021Z"
          fill={fill}
        />
        <path
          d="M11.7467 11.0801H8.24667C7.97334 11.0801 7.74667 10.8534 7.74667 10.5801C7.74667 10.3067 7.97334 10.0801 8.24667 10.0801H11.7467C12.02 10.0801 12.2467 10.3067 12.2467 10.5801C12.2467 10.8534 12.0267 11.0801 11.7467 11.0801Z"
          fill={fill}
        />
        <path
          d="M4.74665 11.5862C4.61999 11.5862 4.49332 11.5396 4.39332 11.4396L3.89332 10.9396C3.69999 10.7462 3.69999 10.4262 3.89332 10.2329C4.08665 10.0396 4.40665 10.0396 4.59999 10.2329L4.74665 10.3796L5.89332 9.23289C6.08665 9.03956 6.40665 9.03956 6.59999 9.23289C6.79332 9.42622 6.79332 9.74622 6.59999 9.93956L5.09999 11.4396C5.00665 11.5329 4.87999 11.5862 4.74665 11.5862Z"
          fill={fill}
        />
        <path
          d="M10 15.1663H6.00001C2.38001 15.1663 0.833344 13.6197 0.833344 9.99967V5.99967C0.833344 2.37967 2.38001 0.833008 6.00001 0.833008H10C13.62 0.833008 15.1667 2.37967 15.1667 5.99967V9.99967C15.1667 13.6197 13.62 15.1663 10 15.1663ZM6.00001 1.83301C2.92668 1.83301 1.83334 2.92634 1.83334 5.99967V9.99967C1.83334 13.073 2.92668 14.1663 6.00001 14.1663H10C13.0733 14.1663 14.1667 13.073 14.1667 9.99967V5.99967C14.1667 2.92634 13.0733 1.83301 10 1.83301H6.00001Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ListSVG;
